import { Injectable } from '@angular/core';
import { ReferenceDataConstants } from '../constants/reference-data-constants';
import { UserPermissions } from '../constants/user-permissions';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {
  private permissions: Array<string>;

  public getPermissions(): Array<string> {
    return this.permissions;
  }

  public setPermissions(permissions: Array<string>): void {
    this.permissions = permissions;
  }

  public hasPermission(permission: string): boolean {
    return this.permissions.indexOf(permission) !== -1;
  }

  public hasPermissions(permissions: Array<string>): boolean {
    return this.permissions.some((permission) => permissions.indexOf(permission) !== -1);
  }

  public hasViewUserPermissions(interfaceId: number): boolean {
    let userPermissions: Array<string>;
    switch (interfaceId) {
      case ReferenceDataConstants.BROKER_INTERFACE_TYPE_ID: {
        userPermissions = [UserPermissions.ManageBrokerUsers, UserPermissions.ViewBrokerUsers];
        break;
      }
      case ReferenceDataConstants.BRANCH_INTERFACE_TYPE_ID: {
        userPermissions = [UserPermissions.ManageBranchUsers, UserPermissions.ViewBranchUsers];
        break;
      }
      case ReferenceDataConstants.DIRECT_INTERFACE_TYPE_ID: {
        userPermissions = [UserPermissions.ManageDirectUsers, UserPermissions.ViewDirectUsers];
        break;
      }
      default: {
        break;
      }
    }

    return this.permissions.some((permission) => userPermissions.indexOf(permission) >= 0);
  }
}
